import { render, staticRenderFns } from "./SupportingStructure.vue?vue&type=template&id=3ef3023e&"
import script from "./SupportingStructure.vue?vue&type=script&lang=js&"
export * from "./SupportingStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports